
export default function ContactHero() {
  return (
    <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/assets/ContactHero.jpg"
          alt="Contact Us"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>
      </div>
      
      <div className="relative z-10 text-center text-white px-4 max-w-5xl mx-auto">
        <h1 className="text-6xl md:text-7xl font-bold mb-6">Let's Connect</h1>
        <p className="text-xl md:text-2xl font-light mb-8">
          Have questions? We're here to help you every step of the way
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a href="#contact-form" className="whitespace-nowrap bg-white text-teal-600 px-8 py-3 rounded-full font-semibold hover:bg-teal-50 transition-all duration-300 shadow-lg cursor-pointer">
            Send a Message
          </a>
          <a href="tel:+912226123456" className="whitespace-nowrap bg-teal-500/20 backdrop-blur-sm text-white border-2 border-white px-8 py-3 rounded-full font-semibold hover:bg-teal-500/30 transition-all duration-300 cursor-pointer">
            Call Now
          </a>
        </div>
      </div>
    </section>
  );
}
